/**
 * HERE Maps tile layer config shared by every `AddressMap`/`AddressInput` consumer across web
 * apps. Only the API key is per-app; the tile style, size, and attribution copy are fixed here so
 * every app agrees on the same tile provider convention.
 */
export const HERE_ATTRIBUTION = 'Map data from <a href="https://www.here.com">HERE</a>';

/** Builds the HERE Maps raster tile URL template for the given app's API key. */
export function createHereTileUrl(apiKey: string): string {
  return `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=logistics.day&size=256&apiKey=${apiKey}`;
}
